<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name':'system-content-links-create'}">Create link</router-link>
            </div>
        </div>

        <content-links-list :items="items" :reload="reload" />
    </div>
</template>
<script>
import contentService from '../../../services/content.service'

import ContentLinksList from '../../common/content/link/content-link-list.vue'

export default {
    name: 'system-content-links',
    components: { ContentLinksList },
    data() {
        return {
            items: []
        }
    },
    async created() {
        await this.reload();
    },
    methods: {
        async reload() {
            this.items = await contentService.listLinks(null);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/links/list.vue